<template>
  <div class="row p-list-representation-wrapper align-items-start w-100">
        <div class="row w-100 p-list-representation-province-main pr-4 pl-4 mt-3">

          <div class=" d-flex flex-wrap p-list-representation-province-data-item w-100">
                <div class="row w-100 flex-column flex-lg-row">

                      <div class="w-100 d-flex flex-wrap p-list-representation-province-data-item mt-4 mb-4">
                            <div class="row p-salon-map-item ml-3 align-items-center">
                              <h3 class="p-salon-map-item-title">نام و نام خانوداگی :</h3>
                              <h3 class="p-salon-map-item-title mr-1">{{formData.nameFamily}}</h3>
                            </div>
                            <div class="row p-salon-map-item ml-3 align-items-center">
                              <h3 class="p-salon-map-item-title"> شماره موبایل : </h3>
                              <h3 class="p-salon-map-item-title  mr-1"> {{formData.mobile}}</h3>
                            </div>
                      </div>
                </div>
          </div>

        </div>

  </div>
</template>

<script>


export default {
  name: "contentList",
  components: {
  },

  props: {
    formData   : {type:[Array,Object],default:[]},
  },

  data() {
    return {

    }
  },

  watch: {

  },

  created() {

  },

  mounted() {
  },

  methods: {

  }


}
</script>
